<ng-container data-testid="upgrade-login" *ngIf="(currentStage$ | async) === Stage.LOGIN">
  <fcom-pnr-widget
    [widgetTitle]="'oneUpgrade.login.heading'"
    [buttonText]="'oneUpgrade.login.submitText'"
    [backgroundImage]="imageData$ | async"
    [error$]="mainError$"
    [disruptions$]="disruptions$"
    [personalizedDisruptions$]="personalized$"
    (formSubmit)="onSubmit($event)"
    (clearError)="closeErrorNotification()"
    [prefilledRecLoc]="(prefillableBookingRef$ | async)?.recLoc"
    [prefilledLastName]="(prefillableBookingRef$ | async)?.lastName"
    [checkForUpgradesTripLink]="true"
  >
  </fcom-pnr-widget>
  <fin-cms-json-content
    class="grid-max-width grid-col-12 no-row-gap"
    [template$]="filteredTemplate$"
  ></fin-cms-json-content>
</ng-container>
